import { CkOutput } from '../CkRichTextEditor/CkOutput';

export interface TextBlockProps {
  content: string;
}

export function TextBlock(props: TextBlockProps) {
  const { content } = props;
  return (
    <div className="p-5 overflow-auto max-h-screen html-rendering">
      <CkOutput data={content} />
    </div>
  );
}

export default TextBlock;
